<template>
  <div>
    <router-view></router-view>
    <audio id="bgMusic" src="https://xmf-pigeon.oss-cn-hangzhou.aliyuncs.com/public/5c894e8c6b62443588.mp3"
           ref="bgMusic"></audio>
  </div>
</template>

<script>
  import { initData } from './api/MsgApi'
  import localforage from 'localforage'

  export default {
    name: 'App.Vue',
    mounted () {
      this.setPlay()
    },
    methods: {
      setPlay () {
        let play = this.$refs.bgMusic
        this.$store.commit('SET_PLAYING', play)
      }
    },
    created () {
    let user=  sessionStorage.getItem('user')
      if (user != null) {
        this.setPlay()
        let _user = JSON.parse(user)
        let db = localforage.createInstance({ name: _user.accountNo + 'DB' })
        this.$store.commit('WEB_DB', db)
        this.$store.dispatch('setUser', _user)
        this.$store.dispatch('socketConnection')
        initData()
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-main {
    padding: 10px !important;
  }

</style>
